import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsRow from './components/StatsRow';
import DividerText from './components/DividerText';
import WhyUs from './components/WhyUs';
import CaseStudies from './components/CaseStudies';
import ServicesInfo from './components/ServicesInfo';
import Process from './components/Process';
import LeadForm from './components/LeadForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-charcoal-950 font-sans selection:bg-gold-500/30 selection:text-charcoal-950">
      <Navbar />
      <main>
        <Hero />
        <StatsRow />
        <DividerText />
        <WhyUs />
        <CaseStudies />
        <ServicesInfo />
        <Process />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;